import type { PropsWithChildren } from 'react';
import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

import type { ThemeProps } from '../theme/theme';
import theme from '../theme/theme';
import type { LocaleProps } from './LocaleProvider';
import { withLocale } from './LocaleProvider';

export type WithTheme<T> = T & { theme?: ThemeProps };

export type ThemeProviderProps = LocaleProps & PropsWithChildren;

const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <EmotionThemeProvider theme={{ ...theme, isHome24: true }}>{children}</EmotionThemeProvider>
);

export default withLocale(ThemeProvider);
